import { Nullable } from "../../../../common/types/nullable";

export type ExpenseForEmployment = Record<string, string | number>;

export enum EmploymentEndReason {
  FixedTermEmploymentEndedAsAgreed = "FixedTermEmploymentEndedAsAgreed",
  EmployeeResigned = "EmployeeResigned",
  Death = "Death",
  FixedTermEmploymentEndedAsAgreedByEmployeeRequest = "FixedTermEmploymentEndedAsAgreedByEmployeeRequest",
  EndedDuringTrialPeriodByEmployee = "EndedDuringTrialPeriodByEmployee",
  EndedDuringTrialPeriodByEmployer = "EndedDuringTrialPeriodByEmployer",
  EmployeeResignedDuringBusinessTransfer = "EmployeeResignedDuringBusinessTransfer",
  EmployeeResignedDuringLayoff = "EmployeeResignedDuringLayoff",
  TerminatedByEmployeeWithoutNotice = "TerminatedByEmployeeWithoutNotice",
  TerminatedByEmployerForEmployeeRelatedReasons = "TerminatedByEmployerForEmployeeRelatedReasons",
  TerminatedByEmployerForEconomicalReasons = "TerminatedByEmployerForEconomicalReasons",
  TerminatedByEmployerForOtherEmployerRelatedReason = "TerminatedByEmployerForOtherEmployerRelatedReason",
  TerminatedByEmployerWithoutNotice = "TerminatedByEmployerWithoutNotice",
  MutualAgreement = "MutualAgreement",
  OldAgePension = "OldAgePension",
  DisabilityPension = "DisabilityPension",
  TransferWithinCorporation = "TransferWithinCorporation",
  EndsDueToBusinessTransfer = "EndsDueToBusinessTransfer",
  ContinuedInAnotherEmployment = "ContinuedInAnotherEmployment",
}

type EndReason = { id: EmploymentEndReason; name: string };

export interface EmploymentBasicInfoFormValues {
  agreedEnd: Nullable<Date>;
  endReason: Nullable<EndReason>;
}
